// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrePayPayment_prepayContainer__zwRkO {
  padding: 20px;
  border: 1px solid #ddd;
}
.PrePayPayment_prepayContainer__zwRkO .PrePayPayment_headerBlock__vVfpK {
  margin-bottom: 20px;
}
.PrePayPayment_prepayContainer__zwRkO .PrePayPayment_headerBlock__vVfpK .PrePayPayment_title__RzyH3 {
  display: block;
  font-size: 28px;
  line-height: 1.2;
  margin-bottom: 10px;
  color: #9e9e9e !important;
  font-weight: 200;
}
.PrePayPayment_prepayContainer__zwRkO .PrePayPayment_headerBlock__vVfpK .PrePayPayment_spacer__yGVYr {
  display: block;
  font-size: 20px;
  margin-bottom: 20px;
}
.PrePayPayment_prepayContainer__zwRkO .PrePayPayment_headerBlock__vVfpK .PrePayPayment_description__UfMam {
  display: block;
  font-size: 20px;
  font-weight: 200;
}
.PrePayPayment_prepayContainer__zwRkO .PrePayPayment_headerBlock__vVfpK .PrePayPayment_description__UfMam a {
  color: var(--link-color);
  text-decoration: underline;
  color: orange;
}
.PrePayPayment_prepayContainer__zwRkO .PrePayPayment_headerBlock__vVfpK .PrePayPayment_description__UfMam a:hover {
  text-decoration: none;
}
.PrePayPayment_prepayContainer__zwRkO .PrePayPayment_selectPaymentBlock__dpIYT {
  margin-bottom: 10px;
}

.PrePayPayment_tru-mma-main-wrapper__kmRR4 {
  box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, 0.75) !important;
  border: 1px solid #ced4da !important;
}

.PrePayPayment_tru-mma-main-grid-block__WulnX, .PrePayPayment_tru-mma-main-wrapper__kmRR4 {
  box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, 0.75);
}

.PrePayPayment_tru-mma-main-collapse-box__HKj0y, .PrePayPayment_tru-mma-main-grid-block__WulnX, .PrePayPayment_tru-mma-main-wrapper__kmRR4 {
  border: 1px solid #ced4da;
}

.PrePayPayment_bg-gray-100__4ugzw {
  background-color: #f5f5f5 !important;
}

@media (max-width: 767px) {
  .PrePayPayment_tru-mma-main-wrapper__kmRR4 {
    box-shadow: none !important;
    border: none !important;
    background: none !important;
  }
  .PrePayPayment_tru-mma-main-content-box__YeDWM {
    border: 0 !important;
  }
}
@media (min-width: 768px) {
  .PrePayPayment_p-md-30__vSzC1 {
    padding: 30px !important;
  }
}
.PrePayPayment_mb-40__0hNI5 {
  margin-bottom: 40px !important;
}

.PrePayPayment_mb-10__TbrQV {
  margin-bottom: 10px !important;
}

.PrePayPayment_g-font-size-30__z3UHE, .PrePayPayment_gfs-30__aE\\+gD {
  font-size: 30px !important;
}

.PrePayPayment_g-font-size-24__o9Yhc, .PrePayPayment_gfs-24__BIFHL {
  font-size: 24px;
}

.PrePayPayment_g-line-height-1_2__\\+\\+esA, .PrePayPayment_glh-1_2__VhXZu {
  line-height: 1.2 !important;
}

.PrePayPayment_text-gray-med__n8iVg {
  color: #9e9e9e !important;
}

.PrePayPayment_g-font-size-20__pW2lU, .PrePayPayment_gfs-20__kOg\\+A {
  font-size: 20px !important;
}

.PrePayPayment_g-font-weight-300__Si-0U, .PrePayPayment_gfw-3__uKQMg {
  font-weight: 300 !important;
}

.PrePayPayment_mb-20__\\+kSS9 {
  margin-bottom: 20px !important;
}

.PrePayPayment_aTag__bo5W4 {
  color: #ffb034 !important;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}`, "",{"version":3,"sources":["webpack://./src/styles/Payments/PrePayPayment.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;AACI;EACI,mBAAA;AACR;AACQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AACZ;AAGQ;EACI,cAAA;EACA,eAAA;EACA,mBAAA;AADZ;AAIQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AAFZ;AAIY;EACI,wBAAA;EACA,0BAAA;EACA,aAAA;AAFhB;AAIgB;EACI,qBAAA;AAFpB;AASI;EACI,mBAAA;AAPR;;AAaA;EACI,2DAAA;EACA,oCAAA;AAVJ;;AAaC;EACG,gDAAA;AAVJ;;AAYA;EACI,yBAAA;AATJ;;AAWA;EACI,oCAAA;AARJ;;AAWA;EACI;IACI,2BAAA;IACA,uBAAA;IACA,2BAAA;EARN;EAUE;IACI,oBAAA;EARN;AACF;AAUA;EACI;IACI,wBAAA;EARN;AACF;AAUA;EACI,8BAAA;AARJ;;AAUA;EACI,8BAAA;AAPJ;;AASA;EACI,0BAAA;AANJ;;AAQA;EACI,eAAA;AALJ;;AAOA;EACI,2BAAA;AAJJ;;AAMA;EACI,yBAAA;AAHJ;;AAKA;EACI,0BAAA;AAFJ;;AAIA;EACI,2BAAA;AADJ;;AAGA;EACI,8BAAA;AAAJ;;AAEA;EACI,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,qCAAA;AACJ","sourcesContent":[".prepayContainer {\n    padding: 20px;\n    border: 1px solid #ddd;\n\n    .headerBlock {\n        margin-bottom: 20px;\n\n        .title {\n            display: block;\n            font-size: 28px;\n            line-height: 1.2;\n            margin-bottom: 10px;\n            color: #9e9e9e !important;\n            font-weight: 200;\n\n        }\n\n        .spacer {\n            display: block;\n            font-size: 20px;\n            margin-bottom: 20px;\n        }\n\n        .description {\n            display: block;\n            font-size: 20px;\n            font-weight: 200;\n\n            a {\n                color: var(--link-color); // Replace with your token\n                text-decoration: underline;\n                color: orange;\n\n                &:hover {\n                    text-decoration: none;\n                }\n            }\n        }\n    }\n\n    // Optional: style wrappers for SelectPaymentBlock and PaymentBlock if needed\n    .selectPaymentBlock {\n        margin-bottom: 10px;\n    }\n\n\n}\n\n.tru-mma-main-wrapper {\n    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75) !important;\n    border: 1px solid #ced4da !important;\n}\n\n .tru-mma-main-grid-block, .tru-mma-main-wrapper {\n    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75);\n}\n.tru-mma-main-collapse-box, .tru-mma-main-grid-block, .tru-mma-main-wrapper {\n    border: 1px solid #ced4da;\n}\n.bg-gray-100 {\n    background-color: #f5f5f5 !important;\n}\n\n@media (max-width: 767px) {    \n    .tru-mma-main-wrapper {\n        box-shadow: none !important;\n        border: none !important;\n        background: none !important;\n    }\n    .tru-mma-main-content-box{\n        border: 0 !important;\n    }\n}\n@media (min-width: 768px) {    \n    .p-md-30 {\n        padding: 30px !important;\n    }\n}\n.mb-40 {\n    margin-bottom: 40px !important;\n}\n.mb-10 {\n    margin-bottom: 10px !important;\n}\n.g-font-size-30, .gfs-30 {\n    font-size: 30px !important;\n}\n.g-font-size-24, .gfs-24 {\n    font-size: 24px;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n.text-gray-med {\n    color: #9e9e9e !important;\n}\n.g-font-size-20, .gfs-20 {\n    font-size: 20px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.mb-20 {\n    margin-bottom: 20px !important;\n}\n.aTag{\n    color: #ffb034 !important;\n    text-decoration: none;\n    background-color: transparent;\n    -webkit-text-decoration-skip: objects;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prepayContainer": `PrePayPayment_prepayContainer__zwRkO`,
	"headerBlock": `PrePayPayment_headerBlock__vVfpK`,
	"title": `PrePayPayment_title__RzyH3`,
	"spacer": `PrePayPayment_spacer__yGVYr`,
	"description": `PrePayPayment_description__UfMam`,
	"selectPaymentBlock": `PrePayPayment_selectPaymentBlock__dpIYT`,
	"tru-mma-main-wrapper": `PrePayPayment_tru-mma-main-wrapper__kmRR4`,
	"tru-mma-main-grid-block": `PrePayPayment_tru-mma-main-grid-block__WulnX`,
	"tru-mma-main-collapse-box": `PrePayPayment_tru-mma-main-collapse-box__HKj0y`,
	"bg-gray-100": `PrePayPayment_bg-gray-100__4ugzw`,
	"tru-mma-main-content-box": `PrePayPayment_tru-mma-main-content-box__YeDWM`,
	"p-md-30": `PrePayPayment_p-md-30__vSzC1`,
	"mb-40": `PrePayPayment_mb-40__0hNI5`,
	"mb-10": `PrePayPayment_mb-10__TbrQV`,
	"g-font-size-30": `PrePayPayment_g-font-size-30__z3UHE`,
	"gfs-30": `PrePayPayment_gfs-30__aE+gD`,
	"g-font-size-24": `PrePayPayment_g-font-size-24__o9Yhc`,
	"gfs-24": `PrePayPayment_gfs-24__BIFHL`,
	"g-line-height-1_2": `PrePayPayment_g-line-height-1_2__++esA`,
	"glh-1_2": `PrePayPayment_glh-1_2__VhXZu`,
	"text-gray-med": `PrePayPayment_text-gray-med__n8iVg`,
	"g-font-size-20": `PrePayPayment_g-font-size-20__pW2lU`,
	"gfs-20": `PrePayPayment_gfs-20__kOg+A`,
	"g-font-weight-300": `PrePayPayment_g-font-weight-300__Si-0U`,
	"gfw-3": `PrePayPayment_gfw-3__uKQMg`,
	"mb-20": `PrePayPayment_mb-20__+kSS9`,
	"aTag": `PrePayPayment_aTag__bo5W4`
};
export default ___CSS_LOADER_EXPORT___;
